import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin, IClickAnalyticsConfiguration } from '@microsoft/applicationinsights-clickanalytics-js';
import { getRuntimeEnv } from '@utils/runtimeEnv';

const connectionString = getRuntimeEnv('REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING');

const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig: IClickAnalyticsConfiguration = {
  autoCapture: true,
  dataTags: {
    useDefaultContentNameOrId: true,
    customDataPrefix: 'data-',
  },
};

// Set by useAuthRoles once the signed-in user's roles are decoded from the token, so every
// event/page view after that carries the role(s) as a queryable custom dimension (lets Usage
// > Cohorts segment by role, e.g. "Windvoice.Approver" users who ran a bulk approval).
let currentUserRoles: string[] = [];
export function setTelemetryUserRole(roles: string[]): void {
  currentUserRoles = roles;
}

export const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
        disableExceptionTracking: false,
        enableAjaxErrorStatusText: true,
        extensions: [clickPluginInstance],
        extensionConfig: {
          [clickPluginInstance.identifier]: clickPluginConfig,
        },
      },
    })
  : null;

if (appInsights) {
  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || {};
    envelope.tags['ai.cloud.role'] = 'nsp-app-frontend';

    envelope.data = envelope.data || {};
    envelope.data.userRole = currentUserRoles.join(',') || 'Unknown';
  });
  appInsights.loadAppInsights();
}
